const _500_dp = (externalBaseUrl: string) => ({
	structure: {
		type: 'Page',
		styleId: '_500_dp_style',
		id: '_500_dp',
		components: [
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-ivs7j2bp',
				dataQuery: '#dataItem-ivs7j2bq',
				layout: {
					width: 701,
					height: 81,
					x: 203,
					y: 379,
					scale: 1.0,
					rotationInDegrees: 0.0,
					fixedPosition: false,
				},
				propertyQuery: 'propItem-ivs7j2bq1',
				componentType: 'wysiwyg.viewer.components.WRichText',
			},
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-ivs7j2bs',
				dataQuery: '#dataItem-ivs7j2bs1',
				layout: {
					width: 475,
					height: 76,
					x: 207,
					y: 482,
					scale: 1.0,
					rotationInDegrees: 0.0,
					fixedPosition: false,
				},
				propertyQuery: 'propItem-ivs7j2bs2',
				componentType: 'wysiwyg.viewer.components.WRichText',
			},
			{
				type: 'Component',
				styleId: 'style-ivs7k3ls',
				id: 'comp-ivs7j2bt',
				dataQuery: '#dataItem-ivs7j2bt1',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
				layout: {
					width: 198,
					height: 56,
					x: 203,
					y: 599,
					scale: 1.0,
					rotationInDegrees: 0.0,
					fixedPosition: false,
				},
				propertyQuery: 'propItem-ivs7j2bu',
				componentType: 'wysiwyg.viewer.components.SiteButton',
			},
			{
				type: 'Component',
				styleId: 'wp2',
				id: 'comp-ivs7j2bw',
				dataQuery: '#dataItem-ivs7j2bw1',
				layout: {
					width: 339,
					height: 235,
					x: 174,
					y: 100,
					scale: 1.0,
					rotationInDegrees: 0.0,
					fixedPosition: false,
				},
				propertyQuery: 'propItem-ivs7j2by',
				componentType: 'wysiwyg.viewer.components.WPhoto',
			},
		],
		mobileComponents: [
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-ivs7j2bp',
				dataQuery: '#dataItem-ivs7j2bq',
				layout: {
					width: 320,
					height: 39,
					x: 0,
					y: 208,
					scale: 0.8084127123905273,
					rotationInDegrees: 0.0,
					anchors: [
						{
							distance: 18,
							originalValue: 265,
							type: 'BOTTOM_TOP',
							locked: true,
							targetComponent: 'comp-ivs7j2bs',
						},
					],
					fixedPosition: false,
				},
				propertyQuery: 'mobile_propItem-ivs7j2bq1',
				componentType: 'wysiwyg.viewer.components.WRichText',
			},
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-ivs7j2bs',
				dataQuery: '#dataItem-ivs7j2bs1',
				layout: {
					width: 277,
					height: 78,
					x: 21,
					y: 265,
					scale: 0.6948499742213815,
					rotationInDegrees: 0.0,
					anchors: [
						{
							distance: 29,
							originalValue: 372,
							type: 'BOTTOM_TOP',
							locked: true,
							targetComponent: 'comp-ivs7j2bt',
						},
					],
					fixedPosition: false,
				},
				propertyQuery: 'mobile_propItem-ivs7j2bs2',
				componentType: 'wysiwyg.viewer.components.WRichText',
			},
			{
				type: 'Component',
				styleId: 'style-ivs7k3ls',
				id: 'comp-ivs7j2bt',
				dataQuery: '#dataItem-ivs7j2bt1',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
				layout: {
					width: 204,
					height: 56,
					x: 53,
					y: 372,
					scale: 0.863837598531476,
					rotationInDegrees: 0.0,
					anchors: [
						{
							distance: 0,
							originalValue: 428,
							type: 'BOTTOM_PARENT',
							locked: true,
							targetComponent: '_500_dp',
						},
					],
					fixedPosition: false,
				},
				propertyQuery: 'propItem-ivs7j2bu',
				componentType: 'wysiwyg.viewer.components.SiteButton',
			},
			{
				type: 'Component',
				styleId: 'wp2',
				id: 'comp-ivs7j2bw',
				dataQuery: '#dataItem-ivs7j2bw1',
				layout: {
					width: 272,
					height: 196,
					x: 24,
					y: -23,
					scale: 1.0,
					rotationInDegrees: 0.0,
					anchors: [
						{
							distance: 35,
							originalValue: 208,
							type: 'BOTTOM_TOP',
							locked: true,
							targetComponent: 'comp-ivs7j2bp',
						},
					],
					fixedPosition: false,
				},
				propertyQuery: 'propItem-ivs7j2by',
				componentType: 'wysiwyg.viewer.components.WPhoto',
			},
		],
		dataQuery: '#_500_dp',
		skin: 'wysiwyg.viewer.skins.page.TransparentPageSkin',
		layout: {
			width: 980,
			height: 675,
			x: 0,
			y: 0,
			scale: 1.0,
			rotationInDegrees: 0.0,
			fixedPosition: false,
		},
		componentType: 'mobile.core.components.Page',
	},
	data: {
		document_data: {
			'dataItem-ivs7j2bq': {
				type: 'StyledText',
				id: 'dataItem-ivs7j2bq',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				text:
					'<h4 class="font_4" style="font-size:66px"><span style="color:#F6A23B"><span style="font-size:66px"><span style="font-family:helvetica-w01-light,helvetica-w02-light,sans-serif">Time&nbsp;Out</span></span></span></h4>\n',
				stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
				linkList: [],
			},
			'dataItem-ivs7j2bs1': {
				type: 'StyledText',
				id: 'dataItem-ivs7j2bs1',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				text:
					'<p class="font_7" style="font-size:22px; line-height:1.7em"><span style="color:#184A56"><span style="font-family:helvetica-w01-light,helvetica-w02-light,sans-serif"><span style="font-size:22px">This page isn&rsquo;t available right now. But we&rsquo;re working on a fix, ASAP. Try again soon. </span></span></span></p>\n',
				stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
				linkList: [],
			},
			'dataItem-ivs7j2bt1': {
				type: 'LinkableButton',
				id: 'dataItem-ivs7j2bt1',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				label: 'Go Back ',
				link: '#dataItem-iwirzq0v',
			},
			'dataItem-ivs7j2bw1': {
				type: 'Image',
				id: 'dataItem-ivs7j2bw1',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				title: '500.png',
				uri: '035244_16f5e2c6277141a6a6e85cdde7b8e53a~mv2.png',
				description: '',
				width: 400,
				height: 282,
				alt: '',
				crop: {
					x: 27,
					y: 21,
					width: 346,
					height: 239,
				},
			},
			'dataItem-iwirzq0v': {
				type: 'ExternalLink',
				id: 'dataItem-iwirzq0v',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				url: externalBaseUrl,
				target: '_self',
			},
			_500_dp: {
				type: 'Page',
				id: '_500_dp',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				title: '500',
				hideTitle: true,
				icon: '',
				descriptionSEO: '',
				metaKeywordsSEO: '',
				pageTitleSEO: '',
				pageUriSEO: '500',
				hidePage: false,
				underConstruction: false,
				tpaApplicationId: 0,
				pageSecurity: {
					requireLogin: false,
				},
				isPopup: false,
				indexable: true,
				isLandingPage: true,
				pageBackgrounds: {
					desktop: {
						custom: true,
						ref: '#customBgImg3vn',
						isPreset: true,
					},
					mobile: {
						custom: true,
						ref: '#customBgImg24ta',
						isPreset: true,
					},
				},
				translationData: {
					uriSEOTranslated: false,
				},
				ignoreBottomBottomAnchors: true,
			},
			customBgImg24ta: {
				type: 'BackgroundMedia',
				id: 'customBgImg24ta',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				color: '#FFFFFF',
				alignType: 'top',
				fittingType: 'fill',
				scrollType: 'fixed',
			},
			customBgImg3vn: {
				type: 'BackgroundMedia',
				id: 'customBgImg3vn',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				color: '#FFFFFF',
				alignType: 'top',
				fittingType: 'fill',
				scrollType: 'fixed',
			},
		},
		design_data: {},
		behaviors_data: {},
		connections_data: {},
		theme_data: {
			'style-ivs7k3ls': {
				type: 'TopLevelStyle',
				id: 'style-ivs7k3ls',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				style: {
					properties: {
						'alpha-bg': '0',
						'alpha-bgh': '1',
						'alpha-brd': '1',
						'alpha-brdh': '0',
						'alpha-txt': '1',
						'alpha-txth': '1',
						bg: '#3EB8EA',
						bgh: '#F6A23B',
						'boxShadowToggleOn-shd': 'false',
						brd: '#F6A23B',
						brdh: '#3D9BE9',
						brw: '2',
						fnt: 'normal normal normal 22px/1.4em helvetica-w01-light',
						rd: '40px',
						shd: '0px 1px 4px 0px rgba(0,0,0,0.6)',
						txt: '#F6A23B',
						txth: '#FFFFF1',
					},
					propertiesSource: {
						'alpha-bg': 'value',
						'alpha-brdh': 'value',
						bg: 'value',
						bgh: 'value',
						brd: 'value',
						brdh: 'value',
						brw: 'value',
						fnt: 'value',
						rd: 'value',
						shd: 'value',
						txt: 'value',
						txth: 'value',
					},
					groups: {},
				},
				componentClassName: 'wysiwyg.viewer.components.SiteButton',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
			},
		},
		component_properties: {
			'mobile_propItem-ivs7j2bq1': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1.0,
				packed: true,
				overrideAlignment: 'center',
			},
			'mobile_propItem-ivs7j2bs2': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1.0,
				packed: true,
			},
			'propItem-ivs7j2bq1': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				brightness: 1.0,
				packed: true,
			},
			'propItem-ivs7j2bs2': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				brightness: 1.0,
				packed: true,
			},
			'propItem-ivs7j2bu': {
				type: 'ButtonProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				align: 'center',
				margin: 0,
			},
			'propItem-ivs7j2by': {
				type: 'WPhotoProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				displayMode: 'fill',
				onClickBehavior: 'goToLink',
				effectName: 'none',
			},
		},
	},
	title: '500',
	pageUriSEO: '500',
})

export default _500_dp
